var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollectD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3768 43.4503L23.328 43.092C23.328 43.092 23.4561 37.7458 21.5375 37.3621C20.2585 35.8785 21.7422 -25.5659 26.3465 37.1575C26.3465 37.1575 24.7607 37.9504 24.4792 39.3062C24.1722 40.6365 24.3768 43.4503 24.3768 43.4503Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3768 43.4503L23.328 43.092C23.328 43.092 23.4561 37.7458 21.5375 37.3621C20.2585 35.8785 21.7422 -25.5659 26.3465 37.1575C26.3465 37.1575 24.7607 37.9504 24.4792 39.3062C24.1722 40.6365 24.3768 43.4503 24.3768 43.4503Z",
    fill: "#A6A385"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9397 38.283C24.9397 38.283 34.123 32.246 31.9743 19.6859C29.9023 10.5538 25.0163 7.56086 24.4792 6.40965C23.8909 5.59112 23.328 4.15869 23.328 4.15869L23.7119 29.5599C23.7119 29.5855 22.9187 37.3364 24.9397 38.283Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9397 38.283C24.9397 38.283 34.123 32.246 31.9743 19.6859C29.9023 10.5538 25.0163 7.56086 24.4792 6.40965C23.8909 5.59112 23.328 4.15869 23.328 4.15869L23.7119 29.5599C23.7119 29.5855 22.9187 37.3364 24.9397 38.283Z",
    fill: "#499D4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.791 38.6155C22.791 38.6155 14.1703 32.7319 14.682 22.372C15.1679 12.0118 21.2561 6.92137 22.4327 6.0004C23.2002 5.18187 23.2258 4.8748 23.277 4.05627C23.8141 5.20748 23.7119 21.272 23.7885 23.1649C24.0188 30.4553 23.3792 37.2343 22.791 38.6155Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.791 38.6155C22.791 38.6155 14.1703 32.7319 14.682 22.372C15.1679 12.0118 21.2561 6.92137 22.4327 6.0004C23.2002 5.18187 23.2258 4.8748 23.277 4.05627C23.8141 5.20748 23.7119 21.272 23.7885 23.1649C24.0188 30.4553 23.3792 37.2343 22.791 38.6155Z",
    fill: "#58AA50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectD);
export default __webpack_public_path__ + "static/media/CollectD.5dbe312b.svg";
export { ForwardRef as ReactComponent };